module.exports = __webpack_public_path__ + "img/print-logo.cf541cd6.png";